/*
  AQUON Bundle Picker
  ===================
  The ONE interaction layer for the bundle Add-to-cart flow (snippets/
  aquon-bundle-picker.liquid). Any product-card bag (+) button marked with
  `data-aqbp-atc` (+ `data-variant-id`) opens the picker, on any page. The trigger
  is the only per-page difference; the flow, pricing, gifts and cart integration
  all live here and read the same shared config the cart engine uses.

  Flow: bag click -> Select Bundle (tier) -> pick flavour(s) -> add ONE pre-priced
  bundle line carrying the chosen flavours as line-item properties, plus that
  tier's gift set (window.AquonBundleFreebies), then open the cart drawer via
  window.AquonCart.addAndOpen. Pack of 1 skips the flavour step (its CTA adds the
  clicked flavour straight away).
*/
(function () {
  'use strict';

  function init() {
    var picker = document.querySelector('[data-aqbp-picker]');
    if (!picker || picker.dataset.aqbpReady === '1') return;
    picker.dataset.aqbpReady = '1';

    var addUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';
    var CTA = picker.getAttribute('data-aqbp-cta') || 'Add to cart';
    var NEXT_CTA = picker.getAttribute('data-aqbp-next-cta') || 'Select Flavours';

    var toast = document.querySelector('[data-aqbp-toast]');
    var toastTimer;
    function showToast(msg, isError) {
      if (!toast) return;
      toast.querySelector('.aop__toast-text').textContent = msg;
      toast.classList.toggle('is-error', !!isError);
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.hidden = true; }, 300);
      }, 3200);
    }

    var GIFTS = (window.AquonBundleFreebies && window.AquonBundleFreebies.tiers) || [];
    var bundleEls = Array.prototype.slice.call(picker.querySelectorAll('[data-aqbp-bundle]'));
    var freebieEls = Array.prototype.slice.call(picker.querySelectorAll('[data-aqbp-freebie]'));
    var flavourEls = Array.prototype.slice.call(picker.querySelectorAll('[data-aqbp-flavour]'));
    var stepBundle = picker.querySelector('[data-aqbp-step="bundle"]');
    var stepFlavour = picker.querySelector('[data-aqbp-step="flavour"]');
    var bundleNameEl = picker.querySelector('[data-aqbp-bundle-name]');
    var countEl = picker.querySelector('[data-aqbp-count]');
    var targetEl = picker.querySelector('[data-aqbp-target]');
    var addBtn = picker.querySelector('[data-aqbp-add]');
    var nextBtn = picker.querySelector('[data-aqbp-next]');
    var nextLabel = nextBtn ? nextBtn.querySelector('.apdp__cta-text') : null;
    var selected = bundleEls[0]; // hero (Pack of 3) is preselected, as on the PDP
    var clickedVariantId = null; // the flavour whose bag button opened the picker

    /* Per-product pack tile images. Triggers on AQUON Our Products carry
       data-pack3-img/pack2-img/pack1-img (URLs from product metafields). When any
       are present we swap the 3 tile <img>s so the popup shows THIS product's pouch.
       Other pages (Collection) omit the attributes, so tiles stay on their default
       Tropical Punch image. Originals are cached once so switching between a
       metafield-carrying trigger and a bare one restores the defaults. */
    var packImgHosts = {
      '3': picker.querySelector('[data-aqbp-pack-img="3"]'),
      '2': picker.querySelector('[data-aqbp-pack-img="2"]'),
      '1': picker.querySelector('[data-aqbp-pack-img="1"]')
    };
    var packImgOriginals = {};
    Object.keys(packImgHosts).forEach(function (k) {
      var host = packImgHosts[k];
      if (!host) return;
      var img = host.querySelector('img');
      if (!img) return;
      packImgOriginals[k] = {
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || ''
      };
    });
    function applyPackImages(btn) {
      Object.keys(packImgHosts).forEach(function (k) {
        var host = packImgHosts[k];
        if (!host) return;
        var img = host.querySelector('img');
        if (!img) return;
        var url = btn ? (btn.getAttribute('data-pack' + k + '-img') || '') : '';
        if (url) {
          img.setAttribute('src', url);
          img.removeAttribute('srcset');
        } else {
          var o = packImgOriginals[k] || { src: '', srcset: '' };
          if (o.src) img.setAttribute('src', o.src); else img.removeAttribute('src');
          if (o.srcset) img.setAttribute('srcset', o.srcset); else img.removeAttribute('srcset');
        }
      });
    }

    function picksFor(el) { return parseInt(el.getAttribute('data-flavor-picks'), 10) || 1; }
    function tierOf(el) { return parseInt(el.getAttribute('data-tier'), 10) || 0; }

    /* Gift variant ids for a tier come from the shared config, so the picker hands
       out exactly what the cart engine expects to see. */
    function giftsFor(tier) {
      var t = GIFTS.filter(function (x) { return parseInt(x.tier, 10) === tier; })[0];
      return (t && t.gifts) || [];
    }

    function selectBundle(el) {
      selected = el;
      bundleEls.forEach(function (b) { b.classList.toggle('is-selected', b === el); });
      if (bundleNameEl) bundleNameEl.textContent = el.getAttribute('data-name') || '';
      var tier = tierOf(el);
      // Light the freebie tiles this tier unlocks (same unlock_for contract as the PDP).
      freebieEls.forEach(function (f) {
        var list = (f.getAttribute('data-unlock-for') || '').split(',').map(function (x) { return parseInt(x.trim(), 10); });
        f.classList.toggle('is-disabled', list.indexOf(tier) === -1);
      });
      if (targetEl) targetEl.textContent = String(picksFor(el));
      // Pack of 1 needs no flavour step - its CTA adds straight to cart with the
      // clicked flavour. Pack of 2 / 3 open the flavour picker.
      if (nextLabel) nextLabel.textContent = picksFor(el) <= 1 ? CTA : NEXT_CTA;
      // Keep the clicked flavour selected as the shopper switches tiers, so a
      // Pack of 1 direct-add always has its one flavour ready.
      resetFlavours(clickedVariantId);
    }
    function totalPicked() {
      return flavourEls.reduce(function (n, el) {
        return n + (parseInt(el.querySelector('[data-aqbp-qty]').textContent, 10) || 0);
      }, 0);
    }
    function syncCount() {
      var total = totalPicked();
      var need = picksFor(selected);
      if (countEl) countEl.textContent = String(total);
      flavourEls.forEach(function (el) {
        el.querySelector('[data-aqbp-inc]').disabled = total >= need;
        el.classList.toggle('is-selected', (parseInt(el.querySelector('[data-aqbp-qty]').textContent, 10) || 0) > 0);
      });
      addBtn.disabled = total !== need;
    }
    function resetFlavours(preselectVariantId) {
      flavourEls.forEach(function (el) {
        el.querySelector('[data-aqbp-qty]').textContent = '0';
        el.classList.remove('is-selected');
      });
      if (preselectVariantId) {
        var hit = flavourEls.filter(function (el) {
          return el.getAttribute('data-variant-id') === String(preselectVariantId);
        })[0];
        if (hit) hit.querySelector('[data-aqbp-qty]').textContent = '1';
      }
      syncCount();
    }
    function showStep(name) {
      stepBundle.hidden = name !== 'bundle';
      stepFlavour.hidden = name !== 'flavour';
    }
    function openPicker(variantId, triggerBtn) {
      clickedVariantId = variantId; // the flavour whose bag button was clicked
      applyPackImages(triggerBtn);
      picker.hidden = false;
      picker.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      showStep('bundle');
      selectBundle(selected);
    }
    function closePicker() {
      picker.hidden = true;
      picker.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    bundleEls.forEach(function (el) {
      el.addEventListener('click', function () { selectBundle(el); });
    });
    picker.querySelectorAll('[data-aqbp-close]').forEach(function (el) {
      el.addEventListener('click', closePicker);
    });
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        // Pack of 1: no flavour step, add straight to cart. Pack of 2 / 3: pick flavours first.
        if (picksFor(selected) <= 1) { submitCart(nextBtn); return; }
        showStep('flavour');
      });
    }
    var backBtn = picker.querySelector('[data-aqbp-back]');
    if (backBtn) backBtn.addEventListener('click', function () { showStep('bundle'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !picker.hidden) closePicker();
    });
    flavourEls.forEach(function (el) {
      var qty = el.querySelector('[data-aqbp-qty]');
      el.querySelector('[data-aqbp-inc]').addEventListener('click', function () {
        qty.textContent = String((parseInt(qty.textContent, 10) || 0) + 1);
        syncCount();
      });
      el.querySelector('[data-aqbp-dec]').addEventListener('click', function () {
        var n = parseInt(qty.textContent, 10) || 0;
        if (n > 0) qty.textContent = String(n - 1);
        syncCount();
      });
    });

    /* Shared add-to-cart. Called by the flavour-step ADD button (Pack 2/3) and by
       the step-1 CTA directly (Pack of 1). Builds one bundle line carrying the
       chosen flavours as properties, plus the tier's gift. triggerBtn is whichever
       button to show the loading spinner on. */
    function submitCart(triggerBtn) {
      // Flavour names show in the cart; the _variant_<id> keys are hidden (leading
      // underscore) and tell fulfilment which packs to pick.
      var props = {};
      flavourEls.forEach(function (el) {
        var n = parseInt(el.querySelector('[data-aqbp-qty]').textContent, 10) || 0;
        if (!n) return;
        var name = el.querySelector('[data-aqbp-flavour-name]').textContent.trim();
        props[name] = String(n);
        props['_variant_' + el.getAttribute('data-variant-id')] = String(n);
      });
      var items = [{ id: parseInt(selected.getAttribute('data-bundle-variant'), 10), quantity: 1, properties: props }];
      giftsFor(tierOf(selected)).forEach(function (g) {
        items.push({ id: parseInt(g, 10), quantity: 1, properties: { _gift: 'true' } });
      });

      var sp = triggerBtn.querySelector('.aop-picker__spinner');
      triggerBtn.classList.add('is-loading');
      if (sp) sp.classList.remove('hidden');
      var finish = function () {
        triggerBtn.classList.remove('is-loading');
        if (sp) sp.classList.add('hidden');
      };
      var onOk = function () { finish(); closePicker(); };
      var onErr = function (err) { finish(); showToast((err && err.description) || 'Could not add to cart', true); };

      if (window.AquonCart && window.AquonCart.addAndOpen) {
        window.AquonCart.addAndOpen(items).then(onOk).catch(onErr);
        return;
      }
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) return onErr(res.d);
          onOk();
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          showToast('Added to cart', false);
        })
        .catch(function () { onErr(); });
    }

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      submitCart(addBtn);
    });

    /* Trigger: any product-card bag (+) button on the page. This is the ONLY thing
       that differs per page - the home-page card and the collection card both just
       mark their bag button with data-aqbp-atc + data-variant-id. */
    document.querySelectorAll('[data-aqbp-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openPicker(btn.getAttribute('data-variant-id'), btn);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
